import { DateTime } from 'luxon'

// #region https://prisync.atlassian.net/browse/WEG-1572

// compare with 04:00, 11:00, 19:00 utc plus 2 hours
//  for the sense of "during the cycle interval"
const engineCycles = ['06:00', '13:00', '21:00']
// compare with feed processing time of the day
const feedCycles = ['06:00']

const findNearestCycle = (
  nowForUser: DateTime,
  timezone: string,
  cycleFrequency: string,
  cycles: string[],
): DateTime => {
  const cycleFrequencies = cycleFrequency.split('')

  // cycle frequency is a string that consists of 1 or 0s total of cycle counts
  //  should have at least one '1', exp. '110', '111', '010'
  if (cycleFrequencies.indexOf('1') === -1) {
    // this is actually an error on data but silently handle it with a fallback
    return DateTime.utc().startOf('year').setZone(timezone) as DateTime
  }

  let nearestCycle = null

  for (let index = cycleFrequencies.length - 1; index >= 0; index--) {
    if (cycleFrequencies[index] !== '1') {
      continue
    }

    const [cycleHours, cycleMinutes] = cycles[index].split(':')
    nearestCycle = nowForUser
      .startOf('day')
      .plus({ hours: +cycleHours, minutes: +cycleMinutes }) as DateTime

    if (nearestCycle < nowForUser) {
      break
    }
  }

  if (!nearestCycle || nearestCycle > nowForUser) {
    return findNearestCycle(
      nowForUser.minus({ hours: 24 }).endOf('day'),
      timezone,
      cycleFrequency,
      cycles,
    )
  }
  return nearestCycle
}

export { findNearestCycle, engineCycles, feedCycles }
// #endregion
